import React, { useContext, useEffect, useState } from 'react';
import Price from '../shop/Price';
import CartContext from '../../../contexts/CartContext';
import CartUtils from '../../../utils/CartUtils';

type Props = {
  items: ICartItem[]
}


const Total = ({ items }: Props) => {
  const {cart, setCartState} = useContext(CartContext);
  const [total, setTotal] = useState<number|undefined>(undefined);

  useEffect(() => {
    // Guard against the cart-clear-then-navigate sequence at order
    // submission: cart changes (items emptied) → effect re-runs → before
    // the async getTotal resolves, history.push unmounts CheckoutPage.
    // Without this, the resolve fires setTotal on an unmounted component.
    let cancelled = false;
    (async () => {
      const utils = new CartUtils(cart);
      const t = await utils.getTotal();
      if (!cancelled) setTotal(t);
    })();
    return () => {
      cancelled = true;
    };
  }, [cart]);

  if (total === undefined) {
    return (<></>)
  }
  
  return (
    <Price id='purchase-total' price={total}/>
  )
}

export default Total